import { useContext, useEffect, useMemo } from 'react'
import ModalContext from 'contexts/ModalContext'
import MasterModalContext from 'contexts/MasterModalContext'
import useQueryParams from './useQueryParams'
import { selectLoggedIn } from 'selectors/accountSelectors'
import { useAppDispatch, useAppSelector } from './reduxHooks'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import { matchPath } from 'react-router'
import { replaceSearchString } from 'actions/NavigationActions'

const LOGIN_EXCLUDED_ROUTES = [
  '/:regionCode/checkout',
  '/:regionCode/cart',
  '/:regionCode/account/communication-preferences/unsubscribe',
]

/**
 * Auto opens the sign up modal when 'sign_up' query param is present
 * Modal will not trigger on blacklisted routes.
 */
export default function useShowLoginFromUrl() {
  const showModal = useContext(ModalContext)
  const modalState = useContext(MasterModalContext)
  const query = useQueryParams()
  const isForceLogin = query.has('sign_up')
  const dispatch = useAppDispatch()

  const loggedIn = useAppSelector(selectLoggedIn)
  const currentPath = useAppSelector(state => state.router.location.pathname)

  const isBlacklistedRoute = useMemo(() => {
    return !!matchPath(currentPath, { path: LOGIN_EXCLUDED_ROUTES, exact: false })
  }, [currentPath])

  useEffect(() => {
    if (loggedIn || modalState.open || isBlacklistedRoute) return
    if (!isForceLogin) return
    showModal(<AccountAccessModal initialMode="login" />)
    dispatch(replaceSearchString({
      ...query,
      sign_up: undefined,
    }))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedIn, modalState, isBlacklistedRoute, showModal, dispatch, isForceLogin])
}
